import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

import {
  CarouselWrapper,
  NavButton,
  CarouselImage,
  SkeletonBox,
} from './styles';

const HotelImageCarousel = ({ hotelImages, defaultImage }) => {
  const maxRetries = 20;
  const retryDelay = 1500;

  const [retryMap, setRetryMap] = useState({});
  const [swiperRef, setSwiperRef] = useState(null);
  const [swiperReady, setSwiperReady] = useState(false);
  const [loadedIndexes, setLoadedIndexes] = useState(new Set());

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageLoad = index =>
    setLoadedIndexes(prev => new Set(prev).add(index));

  const handleImageError = (e, imageSrc, index) => {
    const retries = retryMap[index] || 0;
    if (retries < maxRetries) {
      setTimeout(() => {
        setRetryMap(prev => ({ ...prev, [index]: retries + 1 }));
        e.target.src = imageSrc;
      }, retryDelay);
    } else {
      e.target.onerror = null;
      e.target.src = defaultImage;
    }
  };

  const imgLength = hotelImages?.length || 0;
  const loopEnabled = imgLength > 1;

  const slidesPerViewMobile = 1;
  const slidesPerViewDesktop = imgLength >= 3 ? 3 : imgLength || 1;

  const openModal = index => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showNext = e => {
    e.stopPropagation();
    setCurrentIndex((currentIndex + 1) % hotelImages.length);
  };

  const showPrev = e => {
    e.stopPropagation();
    setCurrentIndex(
      (currentIndex - 1 + hotelImages.length) % hotelImages.length
    );
  };

  return (
    <CarouselWrapper>
      <NavButton
        side="left"
        onClick={() => swiperRef?.slidePrev()}
        aria-label="Previous slide"
      >
        &#8249;
      </NavButton>

      <Swiper
        key={imgLength}
        initialSlide={0}
        modules={[Autoplay]}
        onSwiper={swiper => {
          setSwiperRef(swiper);
          setSwiperReady(true);
        }}
        slidesPerView={slidesPerViewMobile}
        breakpoints={{
          600: { slidesPerView: slidesPerViewDesktop },
        }}
        spaceBetween={20}
        loop={loopEnabled}
        loopedSlides={slidesPerViewDesktop + 1}
        centeredSlides={imgLength > 1 && imgLength >= 3}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        style={{ visibility: swiperReady ? 'visible' : 'hidden' }}
      >
        {hotelImages?.map((imageSrc, index) => (
          <SwiperSlide
            key={index}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 300,
              maxWidth: 332,
            }}
          >
            <CarouselImage
              src={imageSrc || defaultImage}
              alt={`Hotel image ${index}`}
              onLoad={() => handleImageLoad(index)}
              onError={e => handleImageError(e, imageSrc, index)}
              onClick={() => openModal(index)}
              style={{
                display: loadedIndexes.has(index) ? 'block' : 'none',
                cursor: 'pointer',
              }}
            />
            {!loadedIndexes.has(index) && <SkeletonBox />}
          </SwiperSlide>
        ))}
      </Swiper>

      <NavButton
        side="right"
        onClick={() => swiperRef?.slideNext()}
        aria-label="Next slide"
      >
        &#8250;
      </NavButton>

      {/* Modal */}
      {isModalOpen && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            cursor: 'pointer',
          }}
        >
          {/* Botón anterior */}
          <button
            onClick={showPrev}
            style={{
              position: 'absolute',
              left: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 60,
              color: 'white',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            &#8249;
          </button>

          {/* Imagen */}
          <img
            src={hotelImages[currentIndex] || defaultImage}
            alt="Hotel full view"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              objectFit: 'contain',
            }}
            onClick={e => e.stopPropagation()}
          />

          {/* Botón siguiente */}
          <button
            onClick={showNext}
            style={{
              position: 'absolute',
              right: 20,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 60,
              color: 'white',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            &#8250;
          </button>
        </div>
      )}
    </CarouselWrapper>
  );
};

export default HotelImageCarousel;
